<template>
  <application-layout>
    <v-container>
      <h1>Conversion Audit Approval Queue</h1>
      <v-tabs v-model="tab" class="mt-3">
        <v-tab
          data-testid="conversion-audit-queue-tab"
          class="conversion-audit-queue-tab"
        >
          Conversion Audit Queue
        </v-tab>
        <v-tab
          data-testid="approved-deals-tab"
          class="approved-deals-tab"
        >
          Approved Deals
        </v-tab>
        <v-tab
          data-testid="denied-deals-tab"
          class="denied-deals-tab"
        >
          Denied Deals
        </v-tab>
        </v-tabs>
          <v-tabs-items v-model="tab">
        <v-tab-item class="mt-4" eager>
          <div class="text-h5 font-weight-bold">Conversion Audit Queue</div>
          <audit-table
            :items="auditDeals"
            :type="'queue'"
            :noDataText="auditDealsLoading ? 'Loading deals...' : 'There are no deals pending.'"
            @dealReviewed="loadDeals"
          />
        </v-tab-item>
        <v-tab-item class="mt-3" eager>
          <div class="text-h5 font-weight-bold">Approved Deals</div>
          <audit-table
            :items="convertedDeals"
            :type="'approved'"
            :noDataText="convertedDealsLoading ? 'Loading deals...' : 'There are no approved deals.'"
            @dealReviewed="loadDeals"
          />
        </v-tab-item>
        <v-tab-item class="mt-3" eager>
          <div class="text-h5 font-weight-bold">Denied Deals</div>
          <audit-table
            :items="deniedDeals"
            :type="'denied'"
            :noDataText="deniedDealsLoading ? 'Loading deals...' : 'There are no denied deals.'"
            @dealReviewed="loadDeals"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";
import AuditTable from "@/views/reporting/partials/AuditTable";

export default {
  data() {
    return {
      auditDealsLoading: false,
      convertedDealsLoading: false,
      deniedDealsLoading: false,

      auditDeals: [],
      convertedDeals: [],
      deniedDeals: [],

      tab: 0
    };
  },

  methods: {
    getDealsNeedingAudit() {
      this.auditDealsLoading = true;
      this.$store.dispatch("getDealsNeedingAudit")
        .then(resp => {
          this.auditDeals = resp.data;
          this.auditDealsLoading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.auditDealsLoading = false;
        });
    },

    getManuallyConvertedDeals() {
      this.convertedDealsLoading = true;
      this.$store.dispatch("getManuallyConvertedDeals")
        .then(resp => {
          this.convertedDeals = resp.data;
          this.convertedDealsLoading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.convertedDealsLoading = false;
        });
    },

    getManuallyDeniedDeals() {
      this.deniedDealsLoading = true;
      this.$store.dispatch("getManuallyDeniedDeals")
        .then(resp => {
          this.deniedDeals = resp.data;
          this.deniedDealsLoading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.deniedDealsLoading = false;
        });
    },

    loadDeals() {
      this.getDealsNeedingAudit();
      this.getManuallyConvertedDeals();
      this.getManuallyDeniedDeals();
    }
  },

  created() {
    this.loadDeals();
  },

  components: {
    ApplicationLayout,
    AuditTable
  }
};
</script>
